module.exports = __webpack_public_path__ + "fonts/heebo-v9-latin-300.b9c9067d.woff2";